var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property, customElement, query } from 'lit/decorators.js';
import styles from './day-selector-item.styles';
import { SgdfElement } from '../../internal/sgdf-element.js';
import { classMap } from 'lit/directives/class-map.js';
import { dateConverter } from '../../internal/date-converter';
let SgdfDaySelectorItem = class SgdfDaySelectorItem extends SgdfElement {
    onClick() {
        this.emit('sgdf-select-date', {
            detail: { date: this.date },
        });
    }
    connectedCallback() {
        super.connectedCallback();
        this.onClick = this.onClick.bind(this);
        this.updateComplete.then(() => {
            this.container.addEventListener('click', this.onClick);
        });
    }
    render() {
        return html `
            <li
                class=${classMap({
            container: true,
            'is-selected': this.selected,
        })}
                tabindex="-1"
            >
                <p class="weekday">
                    ${this.date.toLocaleDateString('fr-FR', {
            weekday: 'short',
        })}
                </p>
                <p class="day">
                    ${this.date.toLocaleDateString('fr-FR', {
            day: '2-digit',
        })}
                </p>
            </li>
        `;
    }
};
SgdfDaySelectorItem.styles = styles;
__decorate([
    property({ converter: dateConverter })
], SgdfDaySelectorItem.prototype, "date", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], SgdfDaySelectorItem.prototype, "selected", void 0);
__decorate([
    query('.container')
], SgdfDaySelectorItem.prototype, "container", void 0);
SgdfDaySelectorItem = __decorate([
    customElement('sgdf-day-selector-item')
], SgdfDaySelectorItem);
export default SgdfDaySelectorItem;
//# sourceMappingURL=day-selector-item.js.map